import { SvgIconProps, SvgIconTypeMap } from '@mui/material/SvgIcon';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useLinearGradient } from 'src/hooks/useLinearGradient';
import Tooltip from '@mui/material/Tooltip';

export type GradientIconProps = SvgIconProps & {
  IconComponent: OverridableComponent<SvgIconTypeMap>;
  gradientColor?: string;
  tooltipTitle?: string;
};

export function GradientIcon({
  IconComponent,
  gradientColor = 'primary.horizontal',
  tooltipTitle = undefined,
  sx,
  ...props
}: GradientIconProps) {
  const gradientId = useLinearGradient(gradientColor);

  return (
    <Tooltip title={tooltipTitle}>
      <>
        <IconComponent
          className="visible"
          {...props}
          sx={{
            fill: `url(#${gradientId})`,
            ...sx,
          }}
        />
      </>
    </Tooltip>
  );
}
